import Reveal from "@/components/feature/Reveal";

const features = [
  {
    icon: "ri-restaurant-2-line",
    title: "Cocina de autor",
    text: "Creatividad y técnica contemporánea en cada plato.",
  },
  {
    icon: "ri-group-line",
    title: "Platos para compartir",
    text: "Ven, siéntate y prueba varios platos con quienes quieres.",
  },
  {
    icon: "ri-heart-3-line",
    title: "Ambiente íntimo",
    text: "Un espacio elegante y acogedor para celebrar momentos que merecen recordarse.",
  },
];

export default function About() {
  return (
    <section id="nosotros" className="w-full bg-cream py-14 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Reveal className="mx-auto max-w-3xl text-center">
          <h2 className="font-serif text-4xl text-darktext md:text-6xl">
            Una mesa para compartir
          </h2>
          <p className="mt-6 text-base leading-relaxed text-darktext/80 md:text-lg">
            CLEM by Cerón redefine la experiencia gastronómica en Armenia. Somos un restaurante de
            autor que combina cocina contemporánea, creatividad, diseño y atención personalizada
            para ofrecer mucho más que una comida: una experiencia sensorial.
          </p>
          <p className="mt-4 text-base leading-relaxed text-darktext/80 md:text-lg">
            Cada plato cuenta una historia y cada detalle del espacio ha sido cuidadosamente
            diseñado para crear un ambiente íntimo, elegante y acogedor.
          </p>
          <p className="mt-6 font-serif text-xl italic text-darktext md:text-2xl">
            En CLEM celebramos los sabores, las emociones y los momentos que merecen ser
            recordados.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-3 md:gap-6">
          {features.map((feature, index) => (
            <Reveal key={feature.title} delay={index * 100}>
              <div className="flex h-full flex-col items-center rounded-xl2 border border-darktext/10 bg-[#fffaf4] p-6 text-center md:p-7">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-malva/15 text-malva">
                  <i className={`${feature.icon} text-2xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-5 font-serif text-2xl text-darktext">{feature.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-darktext/75 md:text-base">
                  {feature.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12">
          <div className="aspect-[4/3] w-full overflow-hidden rounded-xl2 md:aspect-[16/9]">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20intimate%20interior%20of%20an%20elegant%20contemporary%20restaurant%20with%20dark%20walls%2C%20wooden%20tables%20set%20with%20artisanal%20ceramics%2C%20soft%20amber%20pendant%20lighting%2C%20plants%20and%20curated%20decor%2C%20cozy%20fine%20dining%20ambience%2C%20evening%20mood%2C%20editorial%20interior%20photography%2C%20warm%20tonal%20palette&width=1200&height=900&seq=clem-ambiente-interior&orientation=landscape"
              alt="Interior cálido y elegante del restaurante CLEM by Cerón en Armenia"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}